import VideoPopup from "@/components/ui/video-popup";
import { useBreakpoint } from "@/components/useBreakpoint";
import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";

export const Video = () => {
  const sectionRef = useRef<HTMLElement>(null);

  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"]
  });

  const isMobile = !useBreakpoint("md");
  const isTablet = !useBreakpoint("lg");

  const scale = useTransform(
    scrollYProgress,
    [0, 0.5, 1],
    isTablet ? [0.8, 1.1, 0.8] : isMobile ? [0.8, 1.5, 0.8] : [0.8, 1.5, 0.8]
  );

  return (
    <section
      ref={sectionRef}
      id="video"
      className="z-40 relative mt-10 lg:mt-[10em] container flex flex-col items-center justify-center"
    >
      <motion.div style={{ scale }}>
        <VideoPopup
          className="border border-text-foreground/30 rounded-md overflow-clip max-w-[800px] w-full"
          animationStyle="from-center"
          videoSrc="https://www.youtube-nocookie.com/embed/esgTmfNCC-U?autoplay=1&hd=1&hq=1&vq=hd1080p"
          thumbnailSrc="/video3.png"
          thumbnailAlt="Self-hosting Next.js with Dollar Deploy"
        />
      </motion.div>
    </section>
  );
};
